<section id="toggle-text" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Toggleable Text</p>

    <div class="m-t-20">
      <div class="row m-t--20">
        <div class="col-12 m-t-20">
          <toggle-text [qtyWord]="11" [text]="'I`m a toggleable text component receiving param to break at 10 word.'"></toggle-text>
        </div>
      </div>
    </div>
  </div>
</section>
